import { AppState } from './index';

export const selectNews = (state: AppState) => state.newsReducer.news;
export const selectError = (state: AppState) => state.newsReducer.error;
export const selectLoading = (state: AppState) => state.newsReducer.loading;

export const selectCities = (state: AppState) => state.citiesReducer.cities;

export const selectCenters = (state: AppState) => state.centersReducer.centers;
